import { Building } from "../models/site";
import axiosConfig from "./axiosConfig";

const getBuildingsInRegionList = async (
  authToken: string,
  north: number,
  south: number,
  west: number,
  east: number,
  testOrgId?: string | null
): Promise<Building[]> => {
  const { data } = await axiosConfig.get(
    `/building/${north}/${south}/${east}/${west}${
      testOrgId ? `?testOrgId=${testOrgId}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getBuildingsInRegionList;
